/*
 * Copyright (c) 2023. American Express Company
 */

// theirs
import { Hint, Label, SlideStepper } from '@americanexpress/dls-react';
import React from 'react';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';

// ours
import FormatService from 'src/services/format.service';
import { PercentSliderViewModel } from 'src/types/view-models/percent-slider.view.model';

export default function PercentSlider({ id, label, hint, min = -100, max = 100 }: PercentSliderViewModel): JSX.Element {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [field, meta, helpers]: [FieldInputProps<number>, FieldMetaProps<number>, FieldHelperProps<number>] =
        useField(id);
    const { value }: { value: number } = meta;
    const { setValue }: { setValue: (value: number) => void } = helpers;

    return (
        <div data-cy={`${id}PercentSlider`}>
            <Label htmlFor={id}>{label}</Label>
            {hint && <Hint htmlFor={id}>{hint}</Hint>}
            <SlideStepper
                id={id}
                theme={{ paddingBottom: '50px' }}
                min={min}
                max={max}
                step={1}
                value={value}
                onChange={(e: any, value: any) => setValue(value.value)}
            >
                {FormatService.formatPercent(value, 0)}
            </SlideStepper>
        </div>
    );
}
